import { QueryClient } from "@tanstack/react-query";
import { LoaderFunctionArgs } from "react-router";
import { INTERVIEWS_QUERIES } from "~/shared/api/interviews/interviews.queries";
import { JOBS_QUERIES } from "~/shared/api/jobs/jobs.queries";
import {
  ALIGNMENT_SCORE_SHEET_ID,
  CLOSING_NOTES_SHEET_ID,
  INTERVIEW_CLOSING_NOTES_SHEET_ID,
  INTERVIEW_ID_PARAM,
  ROLE_ID_PARAM,
  SHEET_PARAM,
} from "~/team/constants/pipeline.constants";

export function pipelineViewLoader(queryClient: QueryClient, { request }: LoaderFunctionArgs) {
  const url = new URL(request.url);
  const interviewId = url.searchParams.get(INTERVIEW_ID_PARAM);
  const roleId = url.searchParams.get(ROLE_ID_PARAM);
  const sheet = url.searchParams.get(SHEET_PARAM);

  if (!sheet) return null;

  /** Pre-fetch (non-blocking) the sheet data for the alignment score or closing notes sheets */
  switch (sheet) {
    case ALIGNMENT_SCORE_SHEET_ID: {
      if (!interviewId) return null;

      queryClient
        .ensureQueryData({
          ...INTERVIEWS_QUERIES.alignmentScoresList(interviewId),
          retry: false,
        })
        .catch(() => {
          return null;
        });
      return null;
    }
    case INTERVIEW_CLOSING_NOTES_SHEET_ID: {
      queryClient
        .ensureQueryData({
          ...INTERVIEWS_QUERIES.closingNotesList(interviewId),
          retry: false,
        })
        .catch(() => {
          return null;
        });
      return null;
    }
    case CLOSING_NOTES_SHEET_ID: {
      if (!roleId) return null;

      queryClient
        .ensureQueryData({
          ...JOBS_QUERIES.closingNotesList(roleId),
          retry: false,
        })
        .catch(() => {
          return null;
        });
      return null;
    }
    default:
      return null;
  }
}
